export const getPassengerText = (value, plural, singular)=>value === 1 ? `${value} ${(singular || plural).toLowerCase()}` : `${value} ${plural.toLowerCase()}`;
export const transformPassengersValueToText = (value, literals)=>{
    if (!value || !literals) return '';
    const { adults , children , babies , majors  } = value;
    const { value: adultsValue = 0  } = adults ?? {};
    const { value: childrenValue = 0  } = children ?? {};
    const { value: babiesValue = 0  } = babies ?? {};
    const { value: majorsValue = 0  } = majors ?? {};
    const { adultsLabel ='' , adultLabel ='' , childrenLabel ='' , childLabel ='' , babiesLabel ='' , babyLabel ='' , majorsLabel ='' , majorLabel =''  } = literals || {};
    let finalText = getPassengerText(adultsValue, adultsLabel, adultLabel);
    if (childrenValue) finalText += `, ${getPassengerText(childrenValue, childrenLabel, childLabel)}`;
    if (babiesValue) finalText += `, ${getPassengerText(babiesValue, babiesLabel, babyLabel)}`;
    if (majorsValue) finalText += `, ${getPassengerText(majorsValue, majorsLabel, majorLabel)}`;
    return finalText;
};

//# sourceMappingURL=passengers.js.map